import React from "react";
import { Phone, Building2, Mail, MessageSquare, Scale, Lock, FileText, Clock, Zap, ChevronRight } from "lucide-react";

export const Contacts = ({ setCurrentView }) => {
  return (
    <div className="max-w-3xl mx-auto space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold mb-1" style={{fontFamily:'Manrope,sans-serif', color:'var(--rv-text-primary)'}}>Контакты</h1>
        <p style={{color:'var(--rv-text-muted)'}}>Связь с администрацией платформы Reversia</p>
        <p className="text-sm mt-1" style={{color:'var(--rv-text-muted)'}}>Редакция от 4 августа 2026 года</p>
      </div>

      {/* Реквизиты */}
      <div className="reversia-card p-6">
        <h2 className="text-lg font-semibold mb-4 flex items-center gap-2" style={{fontFamily:'Manrope,sans-serif', color:'var(--rv-text-primary)'}}>
          <Building2 size={18} style={{color:'var(--rv-teal)'}}/>Реквизиты администрации
        </h2>
        <div className="grid md:grid-cols-2 gap-6">
          <div className="space-y-3 text-sm">
            <div>
              <p className="font-medium mb-0.5" style={{color:'var(--rv-text-muted)'}}>ФИО администрации</p>
              <p style={{color:'var(--rv-text-primary)'}}>Сумченко О.А.</p>
            </div>
            <div>
              <p className="font-medium mb-0.5" style={{color:'var(--rv-text-muted)'}}>ИНН</p>
              <p className="font-mono font-medium" style={{color:'var(--rv-text-primary)'}}>230808284051</p>
            </div>
          </div>
          <div className="space-y-3 text-sm">
            <div>
              <p className="font-medium mb-0.5" style={{color:'var(--rv-text-muted)'}}>Email поддержки</p>
              <a href="mailto:support@reversia.ru" style={{color:'var(--rv-teal)', textDecoration:'none', fontWeight:500}}>
                support@reversia.ru
              </a>
            </div>
            <div>
              <p className="font-medium mb-0.5" style={{color:'var(--rv-text-muted)'}}>Сотрудничество и реклама</p>
              <a href="mailto:promo@reversia.ru" data-testid="contacts-promo-email" style={{color:'var(--rv-teal)', textDecoration:'none', fontWeight:500}}>promo@reversia.ru</a>
            </div>
            <div>
              <p className="font-medium mb-0.5" style={{color:'var(--rv-text-muted)'}}>Telegram</p>
              <a href="https://t.me/reversia_ru" target="_blank" rel="noopener noreferrer" data-testid="contacts-telegram" style={{color:'var(--rv-teal)', textDecoration:'none', fontWeight:500}}>t.me/reversia_ru (@reversia_ru)</a>
            </div>
            <div>
              <p className="font-medium mb-0.5" style={{color:'var(--rv-text-muted)'}}>Режим работы поддержки</p>
              <p style={{color:'var(--rv-text-primary)'}}>Понедельник — Пятница</p>
              <p style={{color:'var(--rv-text-primary)'}}>9:00 — 18:00 (МСК)</p>
            </div>
          </div>
        </div>
      </div>

      {/* Связь */}
      <div className="reversia-card p-6">
        <h2 className="text-lg font-semibold mb-4 flex items-center gap-2" style={{fontFamily:'Manrope,sans-serif', color:'var(--rv-text-primary)'}}>
          <Mail size={18} style={{color:'var(--rv-teal)'}}/>Связь с нами
        </h2>
        <div className="space-y-4">
          {[
            {
              Icon: MessageSquare,
              title: 'Общие вопросы',
              desc: 'По всем вопросам работы платформы, технической поддержки и сотрудничества',
              href: 'mailto:support@reversia.ru',
              label: 'Написать в поддержку',
            },
            {
              Icon: Scale,
              title: 'Правовые вопросы',
              desc: 'Вопросы по договорам, приватности, спорам и платежам',
              href: 'mailto:support@reversia.ru?subject=Правовой%20вопрос',
              label: 'Задать правовой вопрос',
            },
            {
              Icon: Lock,
              title: 'Вопросы приватности',
              desc: 'Управление персональными данными, GDPR запросы, удаление аккаунта',
              href: 'mailto:support@reversia.ru?subject=Вопрос%20приватности',
              label: 'Вопрос по приватности',
            },
          ].map(({ Icon, title, desc, href, label }) => (
            <div key={title} className="flex items-start gap-4 py-3" style={{borderBottom:'1px solid var(--rv-border)'}}>
              <div className="flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center" style={{background:'rgba(13,148,136,0.08)'}}>
                <Icon size={16} style={{color:'var(--rv-teal)'}}/>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-medium mb-0.5" style={{color:'var(--rv-text-primary)'}}>{title}</h3>
                <p className="text-sm mb-2" style={{color:'var(--rv-text-muted)'}}>{desc}</p>
                <a
                  href={href}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium"
                  style={{background:'var(--rv-teal)', color:'white', textDecoration:'none'}}
                >
                  {label}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Документы */}
      <div className="reversia-card p-6">
        <h2 className="text-lg font-semibold mb-4 flex items-center gap-2" style={{fontFamily:'Manrope,sans-serif', color:'var(--rv-text-primary)'}}>
          <FileText size={18} style={{color:'var(--rv-teal)'}}/>Юридическая информация
        </h2>
        <p className="text-sm mb-3" style={{color:'var(--rv-text-muted)'}}>Все важные документы и правила работы платформы:</p>
        <div className="space-y-2">
          {[
            { view: 'terms', label: 'Публичная оферта' },
            { view: 'privacy', label: 'Политика конфиденциальности' },
          ].map(({ view, label }) => (
            <button
              key={view}
              onClick={() => setCurrentView(view)}
              className="flex items-center gap-2 text-sm w-full text-left py-1"
              style={{color:'var(--rv-teal)', background:'none', border:'none', cursor:'pointer', fontFamily:'IBM Plex Sans,sans-serif'}}
            >
              <ChevronRight size={14}/>{label}
            </button>
          ))}
        </div>
      </div>

      {/* Время ответа */}
      <div className="reversia-card p-6">
        <h2 className="text-lg font-semibold mb-4 flex items-center gap-2" style={{fontFamily:'Manrope,sans-serif', color:'var(--rv-text-primary)'}}>
          <Clock size={18} style={{color:'var(--rv-teal)'}}/>Время ответа
        </h2>
        <div className="grid md:grid-cols-3 gap-4">
          {[
            { Icon: Zap, title: 'Срочные вопросы', time: '2–4 часа в рабочее время' },
            { Icon: MessageSquare, title: 'Обычные вопросы', time: '24 часа в рабочие дни' },
            { Icon: Scale, title: 'Правовые вопросы', time: 'До 3 рабочих дней' },
          ].map(({ Icon, title, time }) => (
            <div key={title} className="text-center p-4 rounded-lg" style={{background:'rgba(13,148,136,0.04)', border:'1px solid rgba(13,148,136,0.1)'}}>
              <Icon size={20} className="mx-auto mb-2" style={{color:'var(--rv-teal)'}}/>
              <h3 className="font-semibold text-sm mb-1" style={{color:'var(--rv-text-primary)'}}>{title}</h3>
              <p className="text-xs" style={{color:'var(--rv-text-muted)'}}>{time}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
